module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_15-0b794c49b990f145288d7e0c8196166b.jpg";